module.exports = __webpack_public_path__ + "static/media/boss-attacking.2ea62638.mp3";